import React from 'react';
import Card from '../../components/elements/Card';
import { Group, Skeleton, Stack } from '@mantine/core';

const LoaderChart = () => {
  return (
    <Card>
      <Group>
        <Stack gap={16} flex={1}>
          <Skeleton w={'60%'} h={16} />
          <Skeleton w={'30%'} h={10} />
        </Stack>
        <Skeleton w={'30%'} h={24} />
      </Group>

      <Skeleton h={200} mt={16} />
    </Card>
  );
};

export default LoaderChart;
